import getCookie from "web/utils/system/cookie/getCookie";
import setCookie from "web/utils/system/cookie/setCookie";

const LOGIN_COUNT_COOKIE = "loginCount";
const SESSION_COUNTED_KEY = "loginCount_counted";
const MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000; // 1 year

/**
 * Increments login count (stored in cookie to survive localStorage.clear).
 * Uses sessionStorage flag to prevent multiple increments on page refresh.
 * sessionStorage is cleared by both clearCache and clearStorageAndRedirectToLogin
 * during logout flow, so the flag resets properly for the next login.
 */
export const incrementLoginCount = (): void => {
  if (sessionStorage.getItem(SESSION_COUNTED_KEY)) return;

  sessionStorage.setItem(SESSION_COUNTED_KEY, "1");
  const current = getLoginCount();
  setCookie(LOGIN_COUNT_COOKIE, String(current + 1), MAX_AGE_MS);
};

export const getLoginCount = (): number => {
  const value = getCookie(LOGIN_COUNT_COOKIE);
  return value ? parseInt(value, 10) : 0;
};
